// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
const validationSchemaFieldFragment = `
 fragment ValidationSchemaField on SchemaValidationFieldInterface {
  name
  ...on ValidationSchemaObjectField {
    fields {
      display
      type
      name
      required
      values {
        code
        label
      }
      validators {
        name
        value
      }
    }
  }
 }
`;
export default validationSchemaFieldFragment;
